<template>
  <div id="app">
    <!-- Begin Scroll Up Button -->
    <form action="#home">
      <button id="toTop" title="Go to top">
        <i class="fas fa-angle-up"></i>
      </button>
    </form>
    <!-- End Scroll Up Button -->

    <Header />
    <component v-bind:is="currentComponent" @changeComponent="changeCurrentComponent" />

    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import './_sass/main.scss'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';

import Header from './components/Header.vue'
import MainContent from './components/MainContent.vue'
import Impressum from './components/Impressum.vue'
import Datenschutz from './components/Datenschutz.vue'

import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy, {
  defaultIconPack: 'fas',
});


export default {
  name: 'App',
  components: {
    Header,
    MainContent,
    Impressum,
    Datenschutz
  },
  data() {
    return {currentComponent: "MainContent"}
  },
  methods: {
    changeCurrentComponent(newComponent) {
      this.currentComponent = newComponent;
    },
    handleScroll() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("toTop").style.display = "block";
      } else {
        document.getElementById("toTop").style.display = "none";
      }
    },
    animatedLinkScoll(newPosition, scrollDuration) {
      var verticalScrollDifference = document.documentElement.scrollTop - newPosition;
      var cosParameter = verticalScrollDifference / 2,
        scrollCount = 0,
        oldTimestamp = performance.now();
      var yOffset = document.documentElement.scrollTop - cosParameter;
      //debugger;
      function step (newTimestamp) {
          scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
          if (scrollCount >= Math.PI) {
            document.documentElement.scrollTop = newPosition;
            return;
          }
          document.documentElement.scrollTop = Math.round(yOffset + cosParameter * Math.cos(scrollCount));
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);

      /*
        Explanations:
        - pi is the length/end point of the cosinus intervall (see above)
        - newTimestamp indicates the current time when callbacks queued by requestAnimationFrame begin to fire.
          (for more information see https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame)
        - newTimestamp - oldTimestamp equals the duration

          a * cos (bx + c) + d                      | c translates along the x axis = 0
        = a * cos (bx) + d                          | d translates along the y axis = 1 -> only positive y values
        = a * cos (bx) + 1                          | a stretches along the y axis = cosParameter = window.scrollY / 2
        = cosParameter + cosParameter * (cos bx)    | b stretches along the x axis = scrollCount = Math.PI / (scrollDuration / (newTimestamp - oldTimestamp))
        = cosParameter + cosParameter * (cos scrollCount * x)
      */
    }
  },
  mounted() {
    var vueJs_this = this;
    window.addEventListener('scroll', this.handleScroll);

    // Smooth Anchor Scrolling
    document.addEventListener('click', function(e) {
      const clickedElement = e.target;
      const anchorElement = clickedElement.tagName.toLowerCase() == 'div' && clickedElement.classList.contains('button') ? clickedElement.parentElement : clickedElement;
      if (anchorElement.tagName.toLowerCase() == 'a' && anchorElement.hash.length > 1 && anchorElement.hash[0] == '#') {
        event.preventDefault();
        const targetId = anchorElement.hash.substring(1);

        vueJs_this.animatedLinkScoll(document.getElementById(targetId).offsetTop, 1000);
      }
    });

    document.querySelector(".preloader-wrapper").style.opacity = 0.0;
    document.querySelector(".preloader-wrapper").style.display = 'none';
    /*
    $(document).on("click", 'a[href^="#"]', function(event) {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top
        },
        500
      );
    });*/
  },
  beforeDestroy() {MainContent
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*/

#toTop {
  height: 50px;
  width: 50px;
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 39;
  border: none;
  outline: none;
  background-color: rgba(31, 44, 108, 0.65);
  color: white;
  cursor: pointer;
  border-radius: 50%;
  font-size: 2rem;
  box-shadow: 0 5px 20px rgba(14, 25, 80, 0.3);
}

#toTop a {
  color: white;
}

#toTop:hover {
  background-color: #43485c;
}

.notices .notification {
    max-width: 100vw;
}
</style>
